// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DatatablesController from "./datatables_controller"
application.register("datatables", DatatablesController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import TagController from "./tag_controller"
application.register("tag", TagController)
